import { topDeck, topDiscard, deck } from '../../stores/cards'
import { clearStores } from '../../stores/cardPLay'
import { getCardToPlay } from '../CardToPlay/cardToPlay.js'

import { computerHandClick } from './ComputerHand.js'
import { computerDeckClick } from './ComputerDeck.js'
import { computerDiscardClick } from './ComputerDiscard'

async function processComputerTurn(params) {
  const { player, computer, deck, CW, goOutScore, endRound } = { ...params }
  
  let targetCard

  clearStores()
  // Set targetCard to null if it fails any step
  console.log('process computer turn')
  const playParams = {
    playerHand: player,
    computerHand: computer,
    sourceCard: topDiscard(),
    goOutScore: goOutScore,
    endRound: endRound
  }
  targetCard = getCardToPlay(playParams)
  // topDiscard selected
  if (targetCard) {
    await wait(CW)
    computerDiscardClick()
    await wait(CW)
    computerHandClick(targetCard, targetCard.handIndex)
    // finish turn
    await wait(CW)
    computerDiscardClick()
    clearStores()
    return
  }

  playParams.sourceCard = topDeck()
  playParams.source = 'deck'

  // Not using top.Discard, use topDeckCard
  targetCard = getCardToPlay(playParams)
  if (targetCard) {
    await wait(CW)
    computerDeckClick(deck)
    await wait(CW)
    computerHandClick(targetCard, targetCard.handIndex)
    await wait(CW)
    // finish turn
    computerDiscardClick()
    clearStores()
  } else {
    await wait(CW)
    computerDeckClick(deck)
    await wait(CW)
    // finish turn
    computerDiscardClick()
    clearStores()
  }
}
async function wait(milliseconds = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve, milliseconds)
  })
}

export { processComputerTurn }
